class ProductGiftCardForm extends window.BAO.CustomElement() {
  static get requiredElements() {
    return ["accordion", "enable"];
  }

  setupListeners() {
    super.setupListeners();

    this.listeners.add(
      this.els.accordion.element,
      "toggle",
      this.onAccordionChange.bind(this),
    );
  }

  onAccordionChange() {
    const requiredInputs =
      this.els.accordion.element.querySelectorAll("[required]");

    this.els.enable.element.value = this.els.accordion.element.open
      ? "true"
      : "false";

    requiredInputs.forEach((input) => {
      input.disabled = !this.els.accordion.element.open;
    });
  }
}

if (!customElements.get("product-gift-card-form")) {
  customElements.define("product-gift-card-form", ProductGiftCardForm);
}
